function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: " M 8 14.711 L 3.111 8.889 L 12.889 8.889 L 8 14.711 Z ",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.222,
  y: 0,
  width: 3.556,
  height: 1.778,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.222,
  y: 2.667,
  width: 3.556,
  height: 1.778,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 6.222,
  y: 5.333,
  width: 3.556,
  height: 4.889,
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 16,
  width: 16,
  height: 1.778,
  fill: "currentColor"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 16 17.778",
    width: "16pt",
    height: "17.778pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7bde89e5.svg";
export { ForwardRef as ReactComponent };